export const referralTranslations = {
  HEB: {
    // Sidebar widget
    widget: {
      title: "הזמן חברים",
      activeDiscount: "הנחה פעילה",
      noDiscount: "הזמינו וקבלו הנחה!",
    },
    // Modal
    modal: {
      tabs: {
        invite: "הזמן",
        status: "סטטוס",
      },
    },
    // Tab 1: Invite
    invite: {
      title: "הזמינו חברים וחסכו!",
      subtitle:
        "על כל חבר שהזמנתם (אחרי תקופת הניסיון)- שניכם מקבלים 5₪ הנחה חודשית",
      howItWorks: "איך זה עובד?",
      step1Title: "שתפו את הלינק",
      step1Desc: "שלחו את הלינק האישי שלכם לחברים",
      step2Title: "החברים עוברים לפרימיום",
      step2Desc:
        "אחרי שהחברים מסיימים את תקופת הניסיון ועוברים למנוי בתשלום — שניכם מקבלים 5₪ הנחה חודשית",
      step3Title: "ככל שתזמינו יותר — תחסכו יותר!",
      step3Desc:
        "כל חבר שמצטרף (ולא ביטל את המנוי) שווה 5₪ הנחה. תקופת הניסיון לא נספרת. אפשר להגיע עד 0₪ בחודש!",
      yourLink: "הלינק האישי שלך",
      copyLink: "העתק לינק",
      copied: "הועתק!",
      shareWhatsApp: "שתף בוואטסאפ",
      whatsappMessage: "היי! 🎁 הצטרף/י למוניטור דרך הלינק שלי וקבל/י ₪5 הנחה על המנוי החודשי!",
      inviteeBonusNote:
        "גם החברים שהזמנתם מקבלים 5₪ הנחה חודשית! ההנחה נשמרת כל עוד שניכם מנויים.",
      heroBadgeAmount: "₪5",
      heroBadgeLine2: "הנחה",
      heroBadgeLine3: "לחודש",
      heroBadgeBelow: "לכל אחד!",
      heroYou: "אתה",
      heroFriend: "החבר",
    },
    // Tab 2: Status
    status: {
      title: "סטטוס ההפניות שלך",
      stats: {
        totalInvited: "סה\"כ הוזמנו",
        activePremium: "פרימיום פעילים",
        yourDiscount: "ההנחה שלך",
      },
      nextPayment: {
        title: "התשלום הבא שלך",
        currentPayment: "תשלום נוכחי",
        nextPaymentDate: "תאריך תשלום הבא",
        originalPrice: "מחיר מקורי",
        affiliateDiscount: "הנחת שותף",
        referralDiscount: "הנחת הפניות",
        accumulatedDiscount: "הנחה צבורה מהפניות",
        inviteeDiscount: "הנחת משתמש מוזמן",
        youPay: "אתה משלם",
        perMonth: "לחודש",
        perYear: "לשנה",
        monthsActive: "חודשים פעילים",
        billingPeriodMonth: "החודש",
        billingPeriodYear: "השנה",
      },
      friendsList: {
        title: "החברים שהזמנת",
        empty: "עדיין לא הזמנת חברים. שתפו את הלינק שלכם!",
        statusActive: "פרימיום פעיל",
        statusPending: "ממתין",
        statusChurned: "לא פעיל",
        joinedOn: "הצטרף ב-",
        perFriend: "₪5 הנחה",
        monthsContributed: "צברת ₪X (Y חודשים)",
      },
    },
    // Zero Hero
    zeroHero: {
      title: "Zero Hero!",
      description: "הגעת ל-₪0 תשלום! קיבלת תג Beta מיוחד כבונוס!",
      badge: "Beta Tester",
      bonus: "בונוס מיוחד: כשמגיעים ל-₪0 תשלום, מקבלים גישה מוקדמת לכל הפיצ׳רים החדשים שלנו לפני כולם!",
    },
    // Help / full program details (plain language, no technical terms)
    help: {
      title: "פרטי תוכנית ההפניה",
      open: "הצג הסבר מפורט",
      close: "סגור",
      intro:
        "על כל חבר שמשלם על מנוי (אחרי תקופת ניסיון) - שניכם מקבלים 5₪ הנחה. יותר חברים = יותר הנחה.",
      howDiscount: "ההנחה נצברת לאורך תקופת המנוי. אחרי כל חיוב היא מופעלת ומתאפסת מחדש.",
      zeroHero:
        "הגעתם ל-0₪? מקבלים תג Beta וגישה מוקדמת לפיצ׳רים חדשים.",
      whenFriendStops:
        "חברים שהפסיקו לשלם? ההנחה עליהם נעצרת מהתשלום הבא.",
      inviteeBonus:
        "גם מי שהוזמנו מקבלים 5₪ הנחה - כל עוד שניכם מנויים.",
      exampleForYourPlan: "דוגמה: הזמנת 5 חברים משלמים",
      exampleMonthly: "מנוי חודשי: ₪49 − ₪25 הנחה = ₪24 לחודש. כל חודש שכולם עדיין מנויים — שוב ₪25 הנחה.",
      exampleYearly: "מנוי שנתי: 5 חברים × ₪5 × 12 חודשים = ₪300 הנחה. ₪489 − ₪300 = ₪189 לשנה. אחרי החיוב מתחילים לצבור מחדש.",
      whenFriendLeavesExample: "אם אחד מ-5 עזב — ההנחה יורדת ב-₪5 לחודש (₪20 במקום ₪25).",
    },
  },
  ENG: {
    // Sidebar widget
    widget: {
      title: "Invite Friends",
      activeDiscount: "active discount",
      noDiscount: "Invite & get a discount!",
    },
    // Modal
    modal: {
      tabs: {
        invite: "Invite",
        status: "Status",
      },
    },
    // Tab 1: Invite
    invite: {
      title: "Invite Friends & Save!",
      subtitle:
        "For each friend you invite (after the trial) — you both get ₪5 off per month",
      howItWorks: "How it works",
      step1Title: "Share your link",
      step1Desc: "Send your personal link to friends",
      step2Title: "Friends move to Premium",
      step2Desc:
        "After friends finish the trial and switch to a paid subscription — you both get ₪5 off per month",
      step3Title: "The more you invite — the more you save!",
      step3Desc:
        "Each friend who joins (and has not cancelled) is worth ₪5 off. The trial period does not count. You can reach ₪0 per month!",
      yourLink: "Your Personal Link",
      copyLink: "Copy Link",
      copied: "Copied!",
      shareWhatsApp: "Share via WhatsApp",
      whatsappMessage: "Hey! 🎁 Join using my link and get ₪5 off your monthly subscription!",
      inviteeBonusNote:
        "Friends you invite also get ₪5 off each month! The discount lasts as long as you're all subscribed.",
      heroBadgeAmount: "₪5",
      heroBadgeLine2: "discount",
      heroBadgeLine3: "monthly",
      heroBadgeBelow: "for each!",
      heroYou: "You",
      heroFriend: "Friend",
    },
    // Tab 2: Status
    status: {
      title: "Your Referral Status",
      stats: {
        totalInvited: "Total Invited",
        activePremium: "Active Premium",
        yourDiscount: "Your Discount",
      },
      nextPayment: {
        title: "Your Next Payment",
        currentPayment: "Current payment",
        nextPaymentDate: "Next payment date",
        originalPrice: "Original price",
        affiliateDiscount: "Partner discount",
        referralDiscount: "Referral discount",
        accumulatedDiscount: "Accumulated referral discount",
        inviteeDiscount: "Invitee discount",
        youPay: "You pay",
        perMonth: "/ month",
        perYear: "/ year",
        monthsActive: "months active",
        billingPeriodMonth: "this month",
        billingPeriodYear: "this year",
      },
      friendsList: {
        title: "Your Invited Friends",
        empty: "You haven't invited any friends yet. Share your link!",
        statusActive: "Active Premium",
        statusPending: "Pending",
        statusChurned: "Inactive",
        joinedOn: "Joined ",
        perFriend: "₪5 off",
        monthsContributed: "₪X earned (Y months)",
      },
    },
    // Zero Hero
    zeroHero: {
      title: "Zero Hero!",
      description: "You reached ₪0 payment! You earned a special Beta badge!",
      badge: "Beta Tester",
      bonus: "Special Bonus: Reach ₪0 payment and get early access to all our latest Beta features before everyone else!",
    },
    // Help / full program details (plain language, no technical terms)
    help: {
      title: "Referral program details",
      open: "Show full explanation",
      close: "Close",
      intro:
        "For each friend who pays for a subscription (after trial) — you both get ₪5 off. More friends = more discount.",
      howDiscount: "The discount accumulates over your billing period. After each charge it's applied and resets.",
      zeroHero:
        "Hit ₪0? You get the Beta badge and early access to new features.",
      whenFriendStops:
        "Friends who stopped paying? Their discount stops from your next payment.",
      inviteeBonus:
        "Invitees also get ₪5 off — as long as you're all subscribed.",
      exampleForYourPlan: "Example: You invite 5 paying friends",
      exampleMonthly: "Monthly plan: ₪49 − ₪25 discount = ₪24/month. Every month they're still subscribed, you get ₪25 off again.",
      exampleYearly: "Yearly plan: 5 friends × ₪5 × 12 months = ₪300 discount. ₪489 − ₪300 = ₪189/year. After the charge, accumulation starts over.",
      whenFriendLeavesExample: "If 1 of 5 leaves — your discount drops by ₪5/month (₪20 instead of ₪25).",
    },
  },
};
